const setAllRiskClassifications = (state, allRiskClassifications) => {
  Object.assign(state, { allRiskClassifications })
}

const setRiskClassifications = (state, riskClassifications) => {
  Object.assign(state, { riskClassifications })
}

const setError = (state, error) => {
  Object.assign(state, { error })
}

const clearError = state => {
  Object.assign(state, { error: null })
}

export default {
  setAllRiskClassifications,
  setRiskClassifications,
  setError,
  clearError
}
